import { render, staticRenderFns } from "./OTPGeneration.vue?vue&type=template&id=798dc548&"
import script from "./OTPGeneration.vue?vue&type=script&lang=js&"
export * from "./OTPGeneration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports